/* ========================================
   VAIDSHALA SHOPIFY THEME — JavaScript
   Uses Shopify AJAX Cart API
   ======================================== */

var FREE_SHIPPING_THRESHOLD = 399;
var FLAT_SHIPPING_COST = 60;

// ---- Loading Screen ----
document.addEventListener('DOMContentLoaded', () => {
    const loader = document.getElementById('loading-screen');
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const delay = isMobile ? 500 : 2200;
    setTimeout(() => {
      if (loader) loader.classList.add('hidden');
    }, delay);
  });
  
  // ---- DOM Ready ----
  document.addEventListener('DOMContentLoaded', () => {
    initNav();
    initCart();
    initScrollAnimations();
    initScrollHeader();
    refreshCartCount();
  });
  
  // ---- Navigation ----
  function initNav() {
    const hamburger = document.getElementById('hamburger');
    const mobileNav = document.getElementById('mobile-nav');
    const closeBtn = document.getElementById('mobile-nav-close');
  
    function openNav() {
      hamburger && hamburger.classList.add('open');
      mobileNav && mobileNav.classList.add('open');
      document.body.classList.add('nav-open');
      document.body.style.overflow = 'hidden';
    }
  
    function closeNav() {
      hamburger && hamburger.classList.remove('open');
      mobileNav && mobileNav.classList.remove('open');
      document.body.classList.remove('nav-open');
      document.body.style.overflow = '';
    }
  
    window.closeMobileNav = closeNav;
  
    hamburger && hamburger.addEventListener('click', function() {
      mobileNav && mobileNav.classList.contains('open') ? closeNav() : openNav();
    });
  
    closeBtn && closeBtn.addEventListener('click', closeNav);
  }
  
  // ---- Sticky Header ----
  function initScrollHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    });
  }
  
  // ---- Cart ----
  function initCart() {
    const cartBtn = document.getElementById('cart-btn');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartClose = document.getElementById('cart-close');
  
    cartBtn?.addEventListener('click', openCart);
    cartClose?.addEventListener('click', closeCart);
    cartOverlay?.addEventListener('click', closeCart);
  
    // Add to cart buttons (product cards)
    document.querySelectorAll('[data-variant-id]').forEach(btn => {
      if (btn.tagName === 'BUTTON') {
        btn.addEventListener('click', () => {
          const variantId = btn.dataset.variantId;
          const title = btn.dataset.productTitle || '';
          addToCartShopify(variantId, 1, title);
        });
      }
    });
  }
  
  async function addToCartShopify(variantId, quantity = 1, title = '') {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity }] })
      });
      const data = await response.json();
      if (response.ok) {
        await refreshCartDrawer();
        openCart();
        const productName = title || (data.items && data.items[0] ? data.items[0].product_title : 'Product');
        showToast('✓ ' + productName.split(' ').slice(0, 3).join(' ') + ' added to cart');
      } else {
        showToast('⚠ ' + (data.description || 'Could not add to cart'));
      }
    } catch (err) {
      showToast('⚠ Something went wrong. Please try again.');
    }
  }
  
  window.addToCartShopify = addToCartShopify;
  
  async function refreshCartDrawer() {
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await response.json();
      renderCartDrawer(cart);
      updateCartBadge(cart.item_count);
    } catch (err) {
      console.error('Cart refresh error:', err);
    }
  }
  
  async function refreshCartCount() {
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await response.json();
      updateCartBadge(cart.item_count);
    } catch (err) {}
  }

  function formatRupees(amount) {
    var rounded = Math.round(amount * 100) / 100;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
  }

  function getShippingAmount(subtotalRupees, itemCount) {
    if (!itemCount) return 0;
    return subtotalRupees >= FREE_SHIPPING_THRESHOLD ? 0 : FLAT_SHIPPING_COST;
  }

  function updateShippingNudge(subtotalRupees, itemCount, shipping) {
    var nudgeEl = document.getElementById('cart-shipping-nudge');
    if (!nudgeEl) return;

    if (itemCount > 0 && shipping > 0) {
      var remaining = Math.max(0, Math.ceil(FREE_SHIPPING_THRESHOLD - subtotalRupees));
      nudgeEl.hidden = false;
      nudgeEl.textContent = 'Free shipping above ₹' + FREE_SHIPPING_THRESHOLD + '. Add ₹' + remaining + ' more — or add another product — to unlock free shipping.';
    } else {
      nudgeEl.hidden = true;
      nudgeEl.textContent = '';
    }
  }
  
  function renderCartDrawer(cart) {
    const itemsEl = document.getElementById('cart-items');
    const subtotalEl = document.getElementById('cart-subtotal');
    const shippingEl = document.getElementById('cart-shipping');
    const totalEl = document.getElementById('cart-total');
    if (!itemsEl) return;
  
    const subtotalRupees = cart.total_price / 100;
    const shipping = getShippingAmount(subtotalRupees, cart.item_count);
    const total = subtotalRupees + shipping;
  
    if (subtotalEl) subtotalEl.textContent = '₹' + formatRupees(subtotalRupees);

    if (shippingEl) {
      if (cart.item_count === 0) {
        shippingEl.textContent = '₹0';
        shippingEl.style.color = '';
        shippingEl.style.fontWeight = '';
      } else if (shipping === 0) {
        shippingEl.textContent = 'FREE';
        shippingEl.style.color = 'var(--sage)';
        shippingEl.style.fontWeight = '500';
      } else {
        shippingEl.textContent = '₹' + formatRupees(shipping);
        shippingEl.style.color = '';
        shippingEl.style.fontWeight = '';
      }
    }

    if (totalEl) totalEl.textContent = '₹' + formatRupees(total);
    updateShippingNudge(subtotalRupees, cart.item_count, shipping);
  
    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="cart-empty">
          <span class="empty-icon">🛒</span>
          <p>Your cart is empty</p>
          <a href="/collections/all" class="btn-outline" onclick="closeCart()" style="margin-top:8px;font-size:0.72rem;padding:10px 20px;">Shop Now</a>
        </div>`;
      return;
    }
  
    itemsEl.innerHTML = cart.items.map((item, idx) => `
      <div class="cart-item">
        <img class="cart-item-img" src="${item.image}" alt="${escapeHtml(item.title)}" onerror="this.src='/assets/toothpaste-hero.jpg'">
        <div class="cart-item-info">
          <div class="cart-item-name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="cart-item-controls">
            <div class="qty-control">
              <button class="qty-btn" onclick="changeCartItemQty('${item.key}', ${item.quantity - 1})">−</button>
              <span class="qty-number">${item.quantity}</span>
              <button class="qty-btn" onclick="changeCartItemQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <div class="cart-item-price">₹${formatRupees(item.line_price / 100)}</div>
          </div>
        </div>
        <button onclick="changeCartItemQty('${item.key}', 0)" style="background:none;border:none;cursor:pointer;color:var(--charcoal-light);font-size:1rem;padding:4px;align-self:flex-start;flex-shrink:0;">✕</button>
      </div>
    `).join('');
  }
  
  async function changeCartItemQty(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await response.json();
      renderCartDrawer(cart);
      updateCartBadge(cart.item_count);
    } catch (err) {
      showToast('⚠ Could not update cart');
    }
  }
  
  window.changeCartItemQty = changeCartItemQty;
  
  function updateCartBadge(count) {
    const badge = document.getElementById('cart-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }
  
  function openCart() {
    const overlay = document.getElementById('cart-overlay');
    const drawer = document.getElementById('cart-drawer');
    overlay?.classList.add('active');
    drawer?.classList.add('active');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  
  function closeCart() {
    document.getElementById('cart-overlay')?.classList.remove('active');
    document.getElementById('cart-drawer')?.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  window.openCart = openCart;
  window.closeCart = closeCart;
  
  // ---- Quick View (image only) ----
  window.openProductQuickView = function(el) {
    const image = el.dataset.productImage;
    const title = el.dataset.productTitle;
    const url = el.dataset.productUrl;
    document.getElementById('quick-view-content').innerHTML = `
      <div style="position:relative;">
        <button onclick="closeQuickView()" style="position:absolute;top:10px;right:10px;font-size:1rem;cursor:pointer;width:32px;height:32px;border-radius:50%;background:white;border:1px solid rgba(0,0,0,0.15);display:flex;align-items:center;justify-content:center;z-index:1;line-height:1;">✕</button>
        <a href="${url}">
          <img src="${image}" style="width:100%;border-radius:12px;object-fit:cover;display:block;" alt="${title}">
        </a>
      </div>`;
    document.getElementById('quick-view-modal').classList.add('active');
    document.body.style.overflow = 'hidden';
  };
  
  window.closeQuickView = function() {
    document.getElementById('quick-view-modal')?.classList.remove('active');
    document.body.style.overflow = '';
  };
  
  // ---- Scroll Animations ----
  function initScrollAnimations() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
  }
  
  // ---- Toast Notification ----
  function showToast(message) {
    let toast = document.getElementById('toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'toast';
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3500);
  }
  
  window.showToast = showToast;
  
  // ---- Smooth scroll for anchor links ----
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
  
  // ---- Helper ----
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(text));
    return div.innerHTML;
  }
